"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var TextArea_styled_exports = {};
__export(TextArea_styled_exports, {
  StyledColumn: () => StyledColumn,
  StyledColumnContainer: () => StyledColumnContainer,
  StyledFullTextAreaProps: () => StyledFullTextAreaProps,
  StyledIcon: () => StyledIcon,
  StyledLabel: () => StyledLabel,
  StyledTextArea: () => StyledTextArea
});
module.exports = __toCommonJS(TextArea_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_mixins = require("../../../themes/mixins");
var import_Icon = require("../../atoms/Icon/Icon.component");
var getTitleColor = function getTitleColor2(theme, errorMode, darkMode, disabled) {
  if (darkMode && disabled) {
    return theme.colors.n[30];
  }
  if (darkMode && errorMode) {
    return theme.colors.n[100];
  }
  if (darkMode) {
    return theme.colors.white;
  }
  if (disabled) {
    return theme.colors.n[60];
  }
  return theme.colors.n[100];
};
var getPlaceholderColor = function getPlaceholderColor2(theme, errorMode, darkMode, disabled) {
  if (darkMode && errorMode) {
    return theme.colors.n[100];
  }
  if (darkMode && disabled) {
    return theme.colors.n[30];
  }
  if (darkMode) {
    return theme.colors.beige[140];
  }
  if (disabled) {
    return theme.colors.n[60];
  }
  return theme.colors.beige[180];
};
var getInputBorder = function getInputBorder2(theme, errorMode) {
  if (errorMode) {
    return "1px solid ".concat(theme.colors.incorrect.base);
  }
  return "1px solid ".concat(theme.colors.beige[180]);
};
var getBackgroundColor = function getBackgroundColor2(theme, errorMode, darkMode, disabled) {
  if (darkMode && disabled) {
    return theme.colors.n[80];
  }
  if (darkMode && errorMode) {
    return theme.colors.status.error[20];
  }
  if (darkMode) {
    return theme.colors.n[100];
  }
  if (disabled) {
    return theme.colors.n[10];
  }
  return theme.colors.white;
};
var getBorderFocusColor = function getBorderFocusColor2(theme, errorMode, darkMode) {
  if (errorMode) {
    return theme.colors.status.error[100];
  }
  return darkMode ? theme.colors.white : theme.colors.beige[180];
};
var getScrollBarBckgColor = function getScrollBarBckgColor2(theme, errorMode, darkMode) {
  if (darkMode) {
    return errorMode ? theme.colors.status.error[20] : theme.colors.n[100];
  }
  return theme.colors.white;
};
var getScrollBarColor = function getScrollBarColor2(theme, errorMode, darkMode) {
  if (darkMode) {
    return errorMode ? theme.colors.n[100] : theme.colors.white;
  }
  return theme.colors.n[100];
};
var StyledFullTextAreaProps = import_styled_components.default.div.withConfig({
  displayName: "TextAreastyled__StyledFullTextAreaProps",
  componentId: "sc-5qnhzt-0"
})(function(_ref) {
  var disabled = _ref.disabled, theme = _ref.theme, rows = _ref.rows, cols = _ref.cols, _ref$resize = _ref.resize, resize = _ref$resize === void 0 ? "both" : _ref$resize, darkMode = _ref.darkMode, errorMode = _ref.errorMode;
  return (0, import_styled_components.css)(["display:inline-block;box-sizing:border-box;color:", ";font-family:", ";font-weight:", ";height:", ";min-height:176px;width:", ";min-width:200px;resize:", ";background:", ";border:", ";cursor:", ";overflow-y:auto;", ";padding:7px 1px 7px 12px;&:focus-within{outline:none;-webkit-appearance:none;border:", ";}"], theme.colors.primary.base, theme.typography.fonts.primary, theme.typography.weights.regular, rows ? "".concat(25.6 * rows, "px") : "176px", cols ? "".concat(8.69 * cols, "px") : "200px", resize, getBackgroundColor(theme, errorMode, darkMode, disabled), getInputBorder(theme, errorMode), disabled ? "not-allowed" : "", (0, import_mixins.withBorderRadius)(), "".concat(theme.measurements.extraSmall, " solid ").concat(getBorderFocusColor(theme, errorMode, darkMode)));
});
var StyledColumnContainer = import_styled_components.default.div.withConfig({
  displayName: "TextAreastyled__StyledColumnContainer",
  componentId: "sc-5qnhzt-1"
})(function() {
  return (0, import_styled_components.css)(["display:flex;flex-direction:row;box-sizing:border-box;height:100%;"]);
});
var StyledColumn = import_styled_components.default.div.withConfig({
  displayName: "TextAreastyled__StyledColumn",
  componentId: "sc-5qnhzt-2"
})(function(_ref2) {
  var icon = _ref2.icon;
  return (0, import_styled_components.css)(["display:flex;flex-direction:column;height:100%;width:", ";margin-right:", ";"], icon ? "" : "100%", icon ? "2%" : "");
});
var StyledLabel = import_styled_components.default.label.withConfig({
  displayName: "TextAreastyled__StyledLabel",
  componentId: "sc-5qnhzt-3"
})(function(_ref3) {
  var theme = _ref3.theme, errorMode = _ref3.errorMode, darkMode = _ref3.darkMode, disabled = _ref3.disabled;
  return (0, import_styled_components.css)(["display:block;font-size:", ";color:", ";align-items:center;cursor:", ";display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;"], theme.typography.sizes.small, getTitleColor(theme, errorMode, darkMode, disabled), disabled ? "not-allowed" : "");
});
var StyledTextArea = import_styled_components.default.textarea.withConfig({
  displayName: "TextAreastyled__StyledTextArea",
  componentId: "sc-5qnhzt-4"
})(function(_ref4) {
  var theme = _ref4.theme, errorMode = _ref4.errorMode, darkMode = _ref4.darkMode, disabled = _ref4.disabled;
  return (0, import_styled_components.css)(["display:block;outline:none;border:none;resize:none;width:100%;height:110%;box-sizing:border-box;font-size:", ";font-family:", ";color:", ";line-height:1.4;padding-right:6px;background:", ";cursor:", ";overflow:hidden;overflow-y:auto;", ";::placeholder{color:", ";}}"], theme.typography.sizes.medium, theme.typography.fonts.primary, getTitleColor(theme, errorMode, darkMode, disabled), getBackgroundColor(theme, errorMode, darkMode, disabled), disabled ? "not-allowed" : "", !disabled && (0, import_mixins.withStyledScrollBar)({
    scrollbarWidth: "extraThin",
    scrollbarHeight: "extraThin",
    backgroundColor: getScrollBarBckgColor(theme, errorMode, darkMode),
    scrollbarColor: getScrollBarColor(theme, errorMode, darkMode)
  }), getPlaceholderColor(theme, errorMode, darkMode, disabled));
});
var StyledIcon = (0, import_styled_components.default)(import_Icon.Icon).withConfig({
  displayName: "TextAreastyled__StyledIcon",
  componentId: "sc-5qnhzt-5"
})(function(_ref5) {
  var theme = _ref5.theme, darkMode = _ref5.darkMode, errorMode = _ref5.errorMode, disabled = _ref5.disabled, activeTextArea = _ref5.activeTextArea;
  return (0, import_styled_components.css)(["color:", ";font-size:17px;margin-top:", ";position:relative;top:2px;"], getTitleColor(theme, errorMode, darkMode, disabled), activeTextArea ? "12px" : "");
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledColumn,
  StyledColumnContainer,
  StyledFullTextAreaProps,
  StyledIcon,
  StyledLabel,
  StyledTextArea
});
//# sourceMappingURL=TextArea.styled.js.map